import script from "./ResultsCount.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultsCount.vue?vue&type=script&setup=true&lang=js"

import "./ResultsCount.vue?vue&type=style&index=0&id=d40baccc&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d40baccc"]])

export default __exports__